import { gql } from '@apollo/client';

export const listConsolidateQC = gql`
  query Query($input: listConsolidatedQcInput) {
    listConsolidatedQc(input: $input) {
      success
      data
      totalCount
      message
    }
  }
`;

export const listShipmentModeApprovalQuery = gql`
  query Query($input: listShipmentModeApprovalInput) {
    listShipmentModeApproval(input: $input) {
      success
      data
      totalCount
      message
    }
  }
`;

export const consolidationSelectionList = gql`
  query ConditionalSelectionList($input: conditionalSelectionListInput) {
    conditionalSelectionList(input: $input) {
      success
      data
      totalCount
      message
      buyerDetails {
        data {
          orgName
          _id
          orgAddress
          orgERPValue
        }
      }
      supplierDetails {
        data {
          orgName
          _id
          orgAddress
        }
      }
    }
  }
`;

export const consolidationSelectionList2 = gql`
  query ConditionalSelectionList($input: conditionalSelectionListInput) {
    conditionalSelectionList(input: $input) {
      success
      data
      totalCount
      message
    }
  }
`;

export const createRequestShipment = gql`
  mutation UpdateRequestShipmentMode($input: updateRequestShipmentModeInput) {
    updateRequestShipmentMode(input: $input)
  }
`;

export const createApprovalShipment = gql`
  mutation UpdateApprovedQuantity($input: updateApprovedQuantityInput) {
    updateApprovedQuantity(input: $input)
  }
`;

export const consolidatedBookingListQuery = gql`
  query Query($input: ConsolidatedBookingListInput) {
    ConsolidatedBookingList(input: $input)
  }
`;

export const consolidatedPendingCount = gql`
  query CountPendingApproval($input: countPendingApprovalInput) {
    countPendingApproval(input: $input) {
      success
      data
      message
    }
  }
`;
